// src/Components/Home/NewsLetter.jsx

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import mailWhite from "../../assets/images/svg/mail-white.svg";
import bigMail from "../../assets/images/svg/big-mail.svg";
import useGeoInfo from "../../useGeoInfo";
import axios from "axios";

const API_BASE = "https://system.yousrygroup.com/api_test/php";
const ENDPOINT = `${API_BASE}/reserve.php`;

const ACCOUNT = "Online";
const PLATFORM = "Google";

const NewsLetter = () => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  const geo = useGeoInfo();
  const [status, setStatus] = useState("idle"); // idle | ok | err | loading
  const [mobile, setMobile] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [messageText, setMessageText] = useState("");
  const [messageClass, setMessageClass] = useState("");

  const handleSubmit = async () => {
    if (!mobile || !selectedService) return;

    setStatus("loading");
    try {
      await axios.post(ENDPOINT, {
        mobile: `+965${mobile}`,
        service: selectedService,
        account: ACCOUNT,
        platform: PLATFORM,
        ...geo,
      });
      setStatus("ok");
      setMobile("");
      setSelectedService("");
    } catch {
      setStatus("err");
    }
  };

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  // 2. عند تغيّر الـ status أو اللغة، حدّد النص والكلاس المناسب
  useEffect(() => {
    if (status === "ok") {
      setMessageText(
        language === "en"
          ? "Subscription successful! Thank you."
          : "تم الاشتراك بنجاح! شكرًا لك."
      );
      setMessageClass("text-green-500 mt-2");
    } else if (status === "err") {
      setMessageText(
        language === "en"
          ? "Subscription failed. Please try again."
          : "فشل الاشتراك، يرجى المحاولة مرة أخرى."
      );
      setMessageClass("text-red-500 mt-2");
    } else {
      setMessageText("");
      setMessageClass("");
    }
  }, [status, language]);

  const services = [
    { key: "international_schools", label: "International Schools" },
    { key: "foundation_stage", label: "Foundation Stage" },
    { key: "quran_studies", label: "Qur'an Studies" },
    { key: "language_learning", label: "Language Learning" },
    { key: "research_assistance", label: "Research and Report Assistance" },
    { key: "private_tutoring", label: "Private Tutoring" },
    { key: "exam_reviews", label: "Exam Reviews" },
    { key: "kuwait_uni_services", label: "Kuwait University Services" },
    { key: "daily_follow_up", label: "Daily Follow-Up" },
    { key: "special_needs_education", label: "Special Needs Education" },
  ];

  return (
    <div
      className="bg-[url('../images/all-img/section-bg-3.png')] bg-cover bg-no-repeat bg-center py-20"
      style={{ marginTop: "120px", marginBottom: "120px" }}
    >
      <div className="container">
        <div className="lg:flex lg:items-center lg:space-x-[70px]">
          <div className="flex-none">
            <div
              className={`flex items-center space-x-8 text-white ${
                i18n.language === "ar" ? "ml-6" : "mr-6"
              } max-w-[327px] mx-auto lg:mb-0 md:mb-10 mb-5`}
            >
              <div className="">
                <img src={bigMail} alt="Newsletter Icon" />
              </div>
              <div className="text-right lg:text-left max-w-[400px]">
                <h2
                  className={`text-white text-2xl font-bold ${
                    i18n.language === "ar" ? "text-right" : "text-left"
                  }`}
                >
                  {t("newsletter.title")}
                </h2>
                <p
                  className={`text-white mt-2 ${
                    i18n.language === "ar" ? "text-right" : "text-left"
                  }`}
                >
                  {t("newsletter.description")}
                </p>
              </div>
            </div>
          </div>

          <div className="">
            <div className="md:flex items-center gap-4 space-y-4 md:space-y-0">
              {/* Phone input with +965 prefix and Kuwait flag */}
              <div
                className={`flex items-center border-b border-[#B2E2DF] w-full bg-transparent rounded px-1 py-2 ${
                  i18n.language === "ar" ? "flex-row" : ""
                }`}
              >
                {/* Prefix only (no flag) */}
                <div
                  className={`flex items-center bg-white bg-opacity-10 px-3 py-1 rounded-full ${
                    i18n.language === "ar" ? "ml-4 flex-row-reverse" : "mr-4"
                  }`}
                >
                  <span className="text-white text-lg font-semibold select-none">
                    +965
                  </span>
                </div>

                {/* Phone Input – max 8 digits only */}
                <input
                  type="tel"
                  placeholder={t("newsletter.phone_placeholder")}
                  name="mobile"
                  value={mobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,8}$/.test(value)) setMobile(value); // only up to 8 digits
                  }}
                  className={`bg-transparent rounded-md text-white placeholder:text-[#B2E2DF] focus:outline-none w-full text-lg px-2"
                  ${i18n.language === "ar" ? "flex-row" : ""}`}
                />
              </div>

              {/* Select box */}
              <select
                name="services"
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                className={`custom-select border-b border-[#fff] bg-transparent text-white placeholder:text-[#B2E2DF] focus:outline-none px-4 py-2 w-full text-lg ${
                  i18n.language === "ar" ? "rtl-arrow" : "ltr-arrow"
                }`}
              >
                <option value="" className="bg-white text-black ">
                  {t("newsletter.select_default")}
                </option>
                {services.map(({ key, label }) => (
                  <option key={key} value={label}>
                    {t(`newsletter.services.${key}`)}
                  </option>
                ))}
              </select>

              {/* Button */}
              {/* existing button */}
              <button
                className="btn bg-white text-secondary w-full md:w-auto"
                onClick={handleSubmit}
                disabled={status === "loading"}
              >
                {t("newsletter.button")}
              </button>

              {messageText && <p className={messageClass}>{messageText}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
